import { render, staticRenderFns } from "./AgentMotorNotifications.vue?vue&type=template&id=1faa4e3c&scoped=true"
import script from "./AgentMotorNotifications.vue?vue&type=script&lang=js"
export * from "./AgentMotorNotifications.vue?vue&type=script&lang=js"
import style0 from "./AgentMotorNotifications.vue?vue&type=style&index=0&id=1faa4e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa4e3c",
  null
  
)

export default component.exports